import React from 'react';
import AsyncSelect from 'react-select/async';
import { GroupBase, StylesConfig, OnChangeValue, mergeStyles } from 'react-select';
import { COMMON_INPUT_LAYOUT_DEFAULT_PROPS, getCommonInputProps } from './BaseInputLayout';
import { Option, MultiSelectInputLayoutProps, MultiSelectInputLayoutType } from 'framework/form';
import { IndicatorsContainer } from './DropdownComponents';
import getDropdownLayoutCommonProps from './dropdownLayoutHelper';
import { useUiTheme } from 'framework/uiTheme';
import { useTheme } from '@mui/material/styles';

const MultiSelectInputLayout: MultiSelectInputLayoutType = ({
  onLoadOptions,
  placeholder,
  onChangeCallback,
  noOptionsMessage,
  value: initialValue,
  menuPortalTarget = document.body,
  isMulti = true,
  styles: customStyles,
  getOptionValue,
  defaultOptions,
  formatOptionLabel,
  ...otherProps
}: MultiSelectInputLayoutProps) => {
  const props = {
    ...COMMON_INPUT_LAYOUT_DEFAULT_PROPS,
    ...otherProps,
  };
  const theme = useTheme();
  const { selectClassName, styles, classNamePrefix } = getDropdownLayoutCommonProps(props, theme);
  const mergedStyles = mergeStyles(styles as StylesConfig<Option, boolean, GroupBase<Option>>, customStyles || {});
  const { BaseInputLayout } = useUiTheme();

  return (
    <BaseInputLayout {...props} placeholder={placeholder} value={initialValue?.length}>
      <AsyncSelect
        {...getCommonInputProps(props)}
        value={initialValue}
        className={selectClassName}
        classNamePrefix={classNamePrefix}
        isMulti={isMulti}
        defaultOptions={defaultOptions}
        loadOptions={onLoadOptions as any}
        placeholder=""
        onChange={(value: OnChangeValue<Option, boolean>) => {
          if (onChangeCallback) {
            onChangeCallback({ target: { value } });
          }
        }}
        noOptionsMessage={noOptionsMessage}
        styles={mergedStyles}
        menuPortalTarget={menuPortalTarget}
        components={{
          IndicatorsContainer,
        }}
        isOptionDisabled={(option: Option) => !!option.disabled}
        getOptionValue={getOptionValue}
        formatOptionLabel={formatOptionLabel}
      />
    </BaseInputLayout>
  );
};

export default MultiSelectInputLayout;
